import React, { useState, useEffect, useContext } from 'react';
import dayjs from 'dayjs';

import { Modal, Form, Row, Col, Input, Button, DatePicker, message } from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { ModalContext } from '../../../../shared/context/ModalContext';

import customer from '../../../../shared/data/customer.json';
import Loading from '../../../../shared/components/Loading/Index';

const { TextArea } = Input;

export default function ModalForm(props) {
    const modal = useContext(ModalContext);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        onLoad();
    }, [props.open]);

    const onLoad = async () => {
        if (!props.open)
            return;

        setLoading(true);

        if (props.id > 0) {
            var findObject = customer.find(m => m.id === props.id);
            findObject.birthDate = dayjs(findObject.birthDate, "DD/MM/YYYY");
            form.setFieldsValue(findObject);
        }

        setLoading(false);
    };

    const onCancel = () => {
        form.resetFields();
        props.onCancel();
    };

    const onSave = async () => {
        var validations = await form.validateFields().then(() => true).catch(() => false);
        if (!validations) {
            message.warning('Por favor completa los datos del formulario.', 7);
            return;
        }

        modal.confirm('¿Esta seguro de realizar la acción?', async () => {
            onCancel();
        });
    };

    return (
        <Modal
            title={`${(props.id === 0 ? 'Nuevo' : 'Modificar')} Cliente`}
            open={props.open}
            destroyOnClose={true}
            onCancel={(prop) => {
                if (!prop.target.className.toString().match("ant-modal-wrap") || prop.type === "keydown")
                    onCancel();
            }}
            width={550}
            footer={[
                <Button key="1" onClick={onCancel} shape='round'>
                    <CloseOutlined /> Cancelar
                </Button>,
                <Button key="2" onClick={onSave} type={'primary'} shape='round'>
                    <SaveOutlined /> Guardar
                </Button>
            ]}
        >
            <Loading visible={loading} text="cargando">
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Row gutter={15} className='mt-20'>
                        <Col span={24}>
                            <Form.Item
                                label="Nombres"
                                name="name"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <Input
                                    placeholder="Ingrese nombre"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Apellidos"
                                name="lastName"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <Input
                                    placeholder="Ingrese apellidos"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Télefono"
                                name="phoneNumber"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <Input
                                    placeholder="Ingrese télefono"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Fecha de Nacimiento"
                                name="birthDate"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <DatePicker
                                    className='w-100'
                                    placeholder="Seleccione una fecha"
                                    format="DD/MM/YYYY"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Dirección"
                                name="address"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <TextArea
                                    rows={4}
                                    placeholder="Ingrese apellidos"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Loading>
        </Modal>
    );
}